import { QBRRounding } from 'partner360/models/qbr/QBRRounding'

export const ROUNDING_VALUES = [QBRRounding.AsIs, QBRRounding.K, QBRRounding.M]
